<template>
  <div>
    <a-card class="customer-filter">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="名称">
              <a-input v-model="filterForm.name" placeholder="名称" class="form-model-item" @change="onSearch" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <a-button type="primary" @click="getDomainList">查询</a-button>
            <a-button :style="{ margin: '0 8px' }" @click="reset">重置</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="业务域列表" size="small" class="filter-data">
      <span slot="extra">
        <a-button v-has="{ code: 'system:domain:add', project: 0 }" class="handle-menu" type="primary" icon="plus" @click="onAdd">添加</a-button>
      </span>
      <a-table :loading="loading" :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="id" @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a v-dis="{ code: 'system:domain:edit', project: 0 }" @click="onEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a v-dis="{ code: 'system:domain:delete', project: 0 }" @click="onDelete(record)">删除</a>
        </span>
        <span slot="logo" slot-scope="text, record">
          <a-avatar shape="square" icon="domain" :src="record.logo" class="table-image" />
        </span>
        <span slot="members" slot-scope="text, record">
          <a-popover title="成员">
            <template slot="content">
              <span v-for="member in record.members" :key="member.id" class="member-info">
                <a-avatar size="small" :src="member.avatar_url" class="table-image" />
                <span>{{ member.nickname }};</span>
              </span>
            </template>
            <span v-for="member in record.members" :key="member.id" class="member-info">{{ member.nickname }};</span>
          </a-popover>
        </span>
        <span slot="owner" slot-scope="text, record">{{ record.owner.nickname }}</span>
        <span slot="project" slot-scope="text, record">{{ record.category.label }}</span>
      </a-table>
    </a-card>
    <domain-modal :is-show="modalVisible" :domain-id="domainId" :domain-data="domainData" @close="close" />
  </div>
</template>

<script>
import DomainModal from '@/pages/system/domain/components/DomainModal';
import { domainList, domainDelete } from '@/api/system/domain';
const columns = [
  {
    title: 'Logo',
    dataIndex: 'logo',
    key: 'logo',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'logo' }
  },
  {
    title: '名称',
    dataIndex: 'name',
    key: 'name',
    width: '10%'
  },
  {
    title: '描述',
    width: '10%',
    key: 'description',
    dataIndex: 'description'
  },
  {
    title: '所属项目',
    key: 'project_name',
    dataIndex: 'project_name'
  },
  {
    title: '所属团队',
    width: '15%',
    key: 'team_name',
    dataIndex: 'team_name'
  },
  {
    title: '负责人',
    key: 'owner',
    dataIndex: 'owner',
    scopedSlots: { customRender: 'owner' }
  },
  {
    title: '成员',
    width: '20%',
    ellipsis: true,
    scopedSlots: { customRender: 'members' }
  },
  {
    title: '创建时间',
    key: 'created_time',
    dataIndex: 'created_time',
    width: 180,
    align: 'center'
  },
  {
    title: '操作',
    width: 120,
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  components: {
    DomainModal
  },
  data() {
    return {
      loading: false,
      filterForm: {
        name: null,
        page_size: 10,
        page_number: 1
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      modalVisible: false,
      domainId: null,
      domainData: {},
      tableData: [],
      columns
    };
  },
  computed: {
    count() {
      return this.expand ? 11 : 7;
    }
  },
  mounted() {
    this.getDomainList();
  },
  methods: {
    // 点击添加
    onAdd() {
      this.domainId = null;
      this.modalVisible = true;
    },

    // 点击编辑
    onEdit(record) {
      this.domainId = record.id;
      this.domainData = record;
      this.modalVisible = true;
    },

    // 删除领域
    onDelete(record) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除该领域吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          const { code, message } = await domainDelete({ id: record.id });
          if (code === 2000) {
            self.$message.success('删除成功');
            self.getDomainList();
          } else {
            self.$message.warning(message);
          }
        }
      });
    },
    toggle() {
      this.expand = !this.expand;
    },

    // 获取领域列表
    getDomainList() {
      this.loading = true;
      domainList(this.filterForm)
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    reset() {
      this.filterForm = {
        name: null,
        category: null,
        level: null,
        page_size: this.pagination.pageSize,
        page_number: 1
      };
      this.getDomainList();
    },

    onSearch() {
      this.filterForm.page_number = 1;
      this.getDomainList();
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.getDomainList();
    },

    // 关闭弹窗
    close() {
      this.modalVisible = false;
      this.getDomainList();
    }
  }
};
</script>

<style lang="less">
.customer-filter {
  margin-bottom: 16px;
}

.handle-menu {
  margin: 0 5px;
}
.search-form .ant-form-item {
  display: flex;
}

.search-form .ant-form-item-control-wrapper {
  flex: 1;
}
</style>
<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0;
}
.member-info {
  margin-left: 4px;
}
</style>
